module.exports = __webpack_public_path__ + "static/media/3ll23.b44beb40.png";